<template>
  <div class="container">
    <b-card no-body class="mt-3">
      <b-card-header>Dashboard</b-card-header>
      <b-card-body class="row">
        <div
          class="col-6"
          style="display: flex;justify-content: center;flex-direction: column;align-items: center;"
        >
          <b-card-title>createTime:{{ getCTime }}</b-card-title>
          <b-card-title>initTime:{{ getITime }}</b-card-title>
        </div>
        <div class="col-6">
          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              normal
              <b-badge variant="primary" pill>{{ runInfo.normal }}</b-badge>
            </b-list-group-item>

            <b-list-group-item class="d-flex justify-content-between align-items-center">
              api
              <b-badge variant="primary" pill>{{ runInfo.api }}</b-badge>
            </b-list-group-item>

            <b-list-group-item class="d-flex justify-content-between align-items-center">
              admin
              <b-badge variant="primary" pill>{{ runInfo.admin }}</b-badge>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-card-body>
    </b-card>
    <b-card no-body class="mt-3">
      <b-card-header>DriveInfo</b-card-header>
      <b-card-body class="p-0">
        <b-table-simple hover outlined responsive>
          <b-thead>
            <b-tr>
              <b-th>path</b-th>
              <b-th>funcName</b-th>
              <b-th>password</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="e in drivesInfos" :key="e.path">
              <b-td>{{ e.path }}</b-td>
              <b-td>{{ e.funcName }}</b-td>
              <b-td>
                <template v-if="e.password">
                  {{ e.password }}
                  <b-dropdown size="lg" variant="link" toggle-class="p-0" no-caret>
                    <template v-slot:button-content>
                      <b-icon icon="reply" aria-hidden="true"></b-icon>
                      <span class="sr-only">Share</span>
                    </template>
                    <b-dropdown-text>Share it</b-dropdown-text>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="getShareUrl(e.path,86400000,e.password)">1天</b-dropdown-item>
                    <b-dropdown-item @click="getShareUrl(e.path,259200000,e.password)">3天</b-dropdown-item>
                    <b-dropdown-item @click="getShareUrl(e.path,604800000,e.password)">7天</b-dropdown-item>
                  </b-dropdown>
                </template>
                <span v-else>none</span>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <p class="text-center">
          <a :href="info">{{ info }}</a>
        </p>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "Dashboard",
  data() {
    return {
      runInfo: {},
      drivesInfos: [],
      info: "#Share the drives with your friends"
    };
  },
  created: function() {
    let _this = this;
    this.common.axios.get("./admin/ajax/dashboard").then(e => {
      console.log(e.data);
      _this.runInfo = e.data.runInfo;
      _this.drivesInfos = e.data.drivesInfos;
    });
  },
  methods: {
    getShareUrl(path, time) {
      let _this = this;
      time = new Date().valueOf() + time;
      _this.info="loading...";
      _this.common.axios.get("./admin/ajax/share",{
        params:{
          path,time
        }
      }).then(e => {
        console.log(e.data);
        _this.info = _this.common.p_h0 + e.data.url;
      });
    }
  },
  computed: {
    getCTime() {
      return this.common.formatDate(this.runInfo.createTime);
    },
    getITime() {
      return this.common.formatDate(this.runInfo.initTime);
    }
  },
  components: {}
};
</script>